module.exports = __webpack_public_path__ + "static/clarity-7e78fb2ac7567253278324a6507314cf.png";